import React, {useEffect, useState} from 'react';

const ResizeComponent = () => {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const footerEl = document.getElementsByTagName("footer");
  const headerEl = document.getElementsByTagName("header");

  const handleResize = () => {
    setWindowWidth(window.innerWidth);

    document.documentElement.style.setProperty('--header-height', `${headerEl[0].clientHeight || 60}px`);
    document.documentElement.style.setProperty('--footer-height', `${footerEl[0].clientHeight || 40}px`);
  };

  useEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return null
};

export default ResizeComponent;